import { Audio, Images, Tweens } from '@abcya/abcya_phaser';
import Phaser from 'phaser';
import FontKeys from '../FontKeys';
import CounterText from '../game/CounterText';
import gameData from '../gameData';
import { ADDITION, MULTIPLICATION } from '../gameParts';
import GameScreen from './GameScreen';

export default class BonusScreen extends Phaser.Scene {
  static get KEY() { return 'BonusScreen'; }

  create() {

    this.introSound = null;
    this.introSound2 = null;
    this.scoreNumber = null;
    this.starCount = 0;
    this.soundChannel = Audio.createSound(this);
    this.playAgainChannel = Audio.createSound(this);

    this.textColors;
    switch (gameData.gameType) {
      case MULTIPLICATION:
        this.textColors = { standard: '#fedf3a', botText: '#000', buttonLabels: '#fedf3a', nextRound: '#000' };
        break;
      case ADDITION:
        this.textColors = { standard: '#ffc12d', botText: '#278ab9', buttonLabels: '#fff', nextRound: '#278ab9' };
        break;
    }

    // tmp values for testing

    // gameData.BONUS_TIME = 4;
    // gameData.LEVEL_SCORE = 45;
    // gameData.STARS_COLLECTED = 3;
    // gameData.CURRENT_LEVEL = 3;

    // gameData.ROUND1_BEST = 2;
    // gameData.ROUND2_BEST = 2;
    // gameData.ROUND3_BEST = 2;

    Images.addImage(0, 0, 'yellow_background', this).setOrigin(0);

    const width = this.scale.width;
    const height = this.scale.height;

    // score background graphic
    this.scoreBackground = Images.addImage(width / 2, height / 2 - 100, 'score_popup', this);

    // round number
    this.roundNumber = this.add.text(458, 218, `${gameData.CURRENT_LEVEL}`, { fontFamily: FontKeys.odin, color: this.textColors.standard, fontSize: '28pt', align: 'center' }).setOrigin(0);

    this.scoreNumber = new CounterText(this, '_VALUE_', 78, this.textColors.standard);
    this.scoreNumber.setValue(0);
    this.scoreNumber.x = width / 2 + 18;
    this.scoreNumber.y = height / 2 - 30;
    this.scoreNumber.textLabel.setOrigin(0.5);
    this.add.existing(this.scoreNumber);

    this.bonusTime = new CounterText(this, '_VALUE_', 58, '#583c13');
    this.bonusTime.setValue(gameData.BONUS_TIME);
    this.bonusTime.x = 138;
    this.bonusTime.y = height / 2 + 4;
    this.bonusTime.textLabel.setOrigin(0.5);
    this.add.existing(this.bonusTime);

    // round best labels
    this.round1Best = this.add.text(655, 330, `${gameData.ROUND1_BEST}`, { fontFamily: FontKeys.odin, color: this.textColors.standard, fontSize: '26pt', align: 'center' }).setOrigin(.5);

    this.round2Best = this.add.text(655, 497, `${gameData.ROUND2_BEST}` , { fontFamily: FontKeys.odin, color: this.textColors.standard, fontSize: '26pt', align: 'center' }).setOrigin(.5);

    this.round3Best = this.add.text(655, 670, `${gameData.ROUND3_BEST}` , { fontFamily: FontKeys.odin, color: this.textColors.standard, fontSize: '26pt', align: 'center' }).setOrigin(.5);

    // if we've completed final level, set global
    if (gameData.CURRENT_LEVEL === 3 && !gameData.ALL_LEVELS_COMPLETED) {

      gameData.ALL_LEVELS_COMPLETED = true;
    }

    if (gameData.CURRENT_LEVEL === 3 || gameData.ALL_LEVELS_COMPLETED) {
      // createjs.Sound.play("deselect", createjs.Sound.INTERRUPT_ANY);

      this.beatScoreText = this.add.text(width / 2, 840, 'SELECT A ROUND TO BEAT YOUR BEST SCORE!' , { fontFamily: FontKeys.odin, color: '#000', fontSize: '22pt', align: 'center' }).setOrigin(0.5, 0);

      // show all 3 round buttons
      this.round2Button = Images.addImage(width / 2, 950, 'blue_button_blank', this).setOrigin(0.5);
      this.round1Button = Images.addImage(this.round2Button.getLeftCenter().x - 41 - this.round2Button.width / 2, 950, 'blue_button_blank', this).setOrigin(0.5);
      this.round3Button = Images.addImage(this.round2Button.getRightCenter().x + 41 + this.round2Button.width / 2, 950, 'blue_button_blank', this).setOrigin(0.5);

      // labels
      this.add.text(this.round1Button.x, this.round1Button.y - 5, '1', { fontFamily: FontKeys.odin, color: this.textColors.buttonLabels, fontSize: '40pt', align: 'center' }).setOrigin(.5);
      this.add.text(this.round2Button.x, this.round2Button.y - 5, '2', { fontFamily: FontKeys.odin, color: this.textColors.buttonLabels, fontSize: '40pt', align: 'center' }).setOrigin(.5);
      this.add.text(this.round3Button.x, this.round3Button.y - 5, '3', { fontFamily: FontKeys.odin, color: this.textColors.buttonLabels, fontSize: '40pt', align: 'center' }).setOrigin(.5);

      this.round1Button.setInteractive();
      this.round2Button.setInteractive();
      this.round3Button.setInteractive();

      this.round1Button.on('pointerdown', () => {this.pickLevelButtonAction(1);});
      this.round2Button.on('pointerdown', () => {this.pickLevelButtonAction(2);});
      this.round3Button.on('pointerdown', () => {this.pickLevelButtonAction(3);});

    }
    else {

      this.nextRoundText = this.add.text(width / 2, 840, 'NEXT ROUND!', { fontFamily: FontKeys.odin, color: this.textColors.nextRound, fontSize: '26pt', align: 'center' }).setOrigin(0.5, 0);

      this.nextRoundButton = Images.addImage(width / 2, 950, 'next_round_button', this).setOrigin(0.5);
      this.nextRoundButton.setInteractive();
      this.nextRoundButton.on('pointerdown', () => {
        this.pickLevelButtonAction(gameData.CURRENT_LEVEL + 1);
      });
    }

    this.soundChannel.play('round_complete_melody');

    // Used in case user leave bonus too quick - added after labels have been created
    let starValue = 0;
    switch (gameData.STARS_COLLECTED) {
      case 1:
        starValue = 10;
        break;
      case 2:
        starValue = 30;
        break;
      case 3:
        starValue = 60;
        break;
    }
    const quickSum = gameData.LEVEL_SCORE + starValue + gameData.BONUS_TIME;
    if (quickSum > gameData[`ROUND${gameData.CURRENT_LEVEL}_BEST`]) {
      gameData[`ROUND${gameData.CURRENT_LEVEL}_BEST`] = quickSum;
    }

    this.time.addEvent({ delay: 3000, callback: () => {this.countScore();}, callbackScope: this });

  };

  pickLevelButtonAction(nextLevel) {

    this.resetGlobals();
    gameData.CURRENT_LEVEL = nextLevel;

    this.cleanUp();
  }

  resetGlobals() {
    gameData.BONUS_TIME = 0;
    gameData.LEVEL_SCORE = 0;
    gameData.STARS_COLLECTED = 0;
  }

  countScore() {

    const timeTaken = this.scoreNumber.countToValue(gameData.LEVEL_SCORE);

    this.soundLoop(timeTaken);

    this.time.addEvent({ delay: timeTaken + 1500, callback: () => {this.countDownBonus();} });

  }

  countDownBonus() {

    this.bonusTime.countDownToValue(0);

    const timeTaken = this.scoreNumber.countToValue(gameData.LEVEL_SCORE + gameData.BONUS_TIME);

    if (gameData.BONUS_TIME > 0) {
      this.soundLoop(timeTaken);
    }

    this.time.addEvent({ delay: timeTaken + 1500, callback: () => {this.countStarBonus();} });

  }

  countStarBonus() {

    if (gameData.STARS_COLLECTED === 0) {
      this.moveScoreToRoundBest();
    }

    if (gameData.STARS_COLLECTED > 0) {

      let starX;
      let starValue;

      switch (this.starCount) {
        case 0:
          starX = this.scale.width / 2 - 46 - 42;
          starValue = 10;
          Audio.playOneShot('star_10', this);
          break;
        case 1:
          starX = this.scale.width / 2 + 48 - 42;
          starValue = 20;
          Audio.playOneShot('star_20', this);
          break;
        case 2:
          starX = this.scale.width / 2 + 140 - 42;
          starValue = 30;
          Audio.playOneShot('star_30', this);
          break;
      }

      const star = new CounterText(this, '_VALUE_', 26, '#583c13', 'star_large');
      star.x = starX;
      star.y = 307;
      star.setValue(starValue);
      star.textLabel.y -= 15;
      this.add.existing(star);

      this.scoreNumber.addValue(starValue);

      Tweens.addTween(star, 10, { scale: 1.8 }, Phaser.Math.Easing.Quadratic.Out,() => {
        Tweens.addTween(star, 500, { scale: 1 }, Phaser.Math.Easing.Quadratic.Out,() => {
          gameData.STARS_COLLECTED--;
          this.starCount++;
          this.countStarBonus();
        });
      });

    }
  }

  moveScoreToRoundBest() {

    if (gameData.CURRENT_LEVEL === 3 || gameData.ALL_LEVELS_COMPLETED) {
      Audio.playOneShot('all-3-rounds-complete', this, 1, false, 0.5, Audio.LOCALIZATION_AUDIO_SPRITE);
    }
    else {
      Audio.playOneShot('next-round', this, 1, false, 0.5, Audio.LOCALIZATION_AUDIO_SPRITE);
    }

    if (this.scoreNumber.getValue() < gameData[`ROUND${gameData.CURRENT_LEVEL}_BEST`] || gameData.CURRENT_LEVEL > 3) {
      return;
    }

    const score = new CounterText(this, '_VALUE_', 26, this.textColors.standard);

    score.x = this.scale.width / 2 + 70;
    score.y = this.scale.height / 2 - 10;

    const value = this.scoreNumber.getValue();
    score.setValue(value);
    this.add.existing(score);
    score.scaleX = 2;
    score.scaleY = 2;

    switch (gameData.CURRENT_LEVEL) {
      case 1:
        Tweens.addTween(score, 500, { scale: 1, x: 655, y: 320 - 10 }, Phaser.Math.Easing.Quadratic.Out, () => {
          this.changeRoundScore();
        });
        break;
      case 2:
        Tweens.addTween(score, 500, { scale: 1, x: 655, y: 320 + 175 - 18 }, Phaser.Math.Easing.Quadratic.Out, () => {
          this.changeRoundScore();
        });
        break;
      case 3:
        Tweens.addTween(score, 500, { scale: 1, x: 655, y: 320 + 350 - 20 }, Phaser.Math.Easing.Quadratic.Out, () => {
          this.changeRoundScore();
        });
        break;
    }
  }

  cleanUp() {

    if (this.playAgainChannel.isPlaying) this.playAgainChannel.stop();

    this.soundChannel.stop();
    this.soundChannel.destroy();
    this.playAgainChannel.destroy();

    this.scene.start(GameScreen.KEY);
  };

  changeRoundScore() {

    if (gameData.CURRENT_LEVEL === 1) {

      this.round1Best.text = `${this.scoreNumber.getValue()}`;
      gameData.ROUND1_BEST = this.scoreNumber.getValue();

    }
    else if (gameData.CURRENT_LEVEL === 2) {

      this.round2Best.text = `${this.scoreNumber.getValue()}`;
      gameData.ROUND2_BEST = this.scoreNumber.getValue();

    } if (gameData.CURRENT_LEVEL === 3) {

      this.round3Best.text = `${this.scoreNumber.getValue()}`;
      gameData.ROUND3_BEST = this.scoreNumber.getValue();

    }
  }

  soundLoop(timeTaken) {
    this.soundChannel.play('score_tally_loop', { loop: true });
    this.time.addEvent({ delay: timeTaken + 100,
      callback: () => {
        this.soundChannel.stop();
        Audio.playOneShot('score_tally_over', this);
      } });
  }
}